<template>
  <div class="container">
    <h3 class="mt-3">Pertanyaan yang sering ditanyakan</h3>
    <p>Lumayan biar bisa mendapatkan jawaban yang kamu cari</p>
    <div>
      <v-expansion-panels v-model="panel" :disabled="disabled" multiple>
        <v-expansion-panel v-for="(item, i) in faqs" :key="i">
          <v-expansion-panel-header>{{
            item.question
          }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            {{ item.answer }}
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <h3 class="mt-8">Hubungi kami</h3>
    <p>Jika terjadi sesuatu atau masih ada pertanyaan lainnya</p>
    <v-btn
      outlined
      large
      color="primary"
      class="mr-3"
      href="https://api.whatsapp.com/send?phone=6285155260901"
      target="_blank"
      >Whatsapp-an Aja</v-btn
    >
    <v-btn
      outlined
      large
      color="primary"
      href="mailto:hi.eventversity@gmail.com"
      target="_blank"
      >Email-lan lebih santai</v-btn
    >
  </div>
</template>

<script>
import Axios from 'axios';

export default {
  name: 'Faq',
  data() {
    return {
      faqs: [],
      loading: false,
      panel: [0],
      disabled: false,
      readonly: false,
    };
  },
  metaInfo() {
    return {
      title: 'Bantuan',
      titleTemplate: '%s - Eventversity',
      htmlAttrs: {
        lang: 'id',
        amp: true,
      },
    };
  },
  mounted() {
    Axios.get(process.env.VUE_APP_API + 'faq')
      .then((response) => {
        this.faqs = response.data.data;
        // console.log(this.faqs);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>

<style scoped>
.v-expansion-panel-header {
  font-weight: bolder;
  line-height: 1.7rem;
}
.v-expansion-panel-content__wrap {
  font-size: 10px !important;
}
</style>
